import config from "src/config";
import http, {
  postWithBasicHeader,
  getWithBasicHeader,
} from "../services/apiServices";
import { isCivilDefenseUser } from "src/utils/helpers";

export const getStatusOptionsApi = async () => {
  return await http.get(config.Case.getCaseStatuses);
};

export const getAppointmentTypesAPI = async () => {
  return await http.postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_appointmenttype",
    EntityName: "has_appointment",
  });
};

export const getCategoryOptionsApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_categoryoflicense",
    EntityName: "has_bmccompany",
  });
};

export const getSystemsAPI = async () => {
  return await getWithBasicHeader(config.lookups.getSystems, {
    OptionSetName: "has_contracttype",
    EntityName: "has_contract",
  });
};

export const getEmiratesOptionsApi = async () => {
  return await postWithBasicHeader(config.lookups.getEmirates, {});
};

export const getCitiesOptionsApi = async (emirateId: string) => {
  return await postWithBasicHeader(config.lookups.getCities, {
    EmirateId: emirateId,
  });
};

export const getCDUCitiesApi = async () => {
  return await http.post(config.lookups.getCDUCities);
};

export const getAppointmentsOnHoldReasonApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_onholdreason",
    EntityName: "has_appointment",
  });
};
export const getAppointmentsStatusesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "statuscode",
    EntityName: "has_appointment",
  });
};
export const getContractTypesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_contracttype",
    EntityName: "has_contract",
  });
};

export const getContractStatusesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName:"statuscode",
    EntityName: "has_contract",
  });
};

export const getCivilDefenseContractApprovalStatusApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_civildefensecontractapprovalstatus",
    EntityName: "has_contract",
  });
};

export const getServiceTerritoriesApi = async (
  isRetrieveByBuilding: boolean,
  cityId: string
) => {
  var api = "";
  if (isCivilDefenseUser()) {
    api = config.lookups.getCDUServiceTerritories;
    isRetrieveByBuilding = true;
  } else {
    api = config.lookups.getServiceTerritories;
  }
  return await http.get(
    `${api}?isRetrieveByBuilding=${isRetrieveByBuilding}&CityId=${cityId}`
  );
};

export const getBuildingsForInvoicesApi = async () => {
  return await http.get(config.lookups.assignedBuildingsForInvoices, {});
};

export const getOnHoldReasonApi = async () => {
  return await http.get(config.lookups.getOnHoldReason, {});
};
export const getApprovalTypesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_typeofapproval",
    EntityName: "has_ownerapprovalrequest",
  });
};
export const getInvoiceStatuesApi = async () => {
  return postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "has_paymentstatus",
    EntityName: "invoice",
  });
};

export const getConsolidatedInvoiceStatuesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "new_paymentstatus",
    EntityName: "new_consolidatedinvoice",
  });
};

export const getAssignedBuildingsAPI = async () => {
  //return await http.get(config.lookups.assignedBuildings);
  const api = isCivilDefenseUser()
    ? config.CivilDefense.getBuildings
    : config.lookups.assignedBuildings;
  return await http.get(api);
};
export const getBuildRequestStatusesApi = async () => {
  return await postWithBasicHeader(config.lookups.getLookupValues, {
    OptionSetName: "new_requeststatus",
    EntityName: "has_changeownershiprequest",
  });
};
